<template>
  <div>
    <tplheader></tplheader>
    <tplLeftPanel></tplLeftPanel>
    <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
      <div class="fixed-top-menu">
        <div class="pull-right">
          <button class="btn btn-primary" type="button" v-on:click="setupDownload()"><i class="fa fa-download"></i>Kártyaolvasó illesztő letöltése</button>
        </div>
      </div>
    </div>
    <div id="main-panel" class="main-panel">
      <div class="content-panel">
        <ul class="breadcrumb">
          <li>
            Kezdőőoldal
          </li>
          <li v-show="false"><a href="#" class="active">Kezdőoldal</a></li>
        </ul>
        <div class="page-title">
          <h1><i class="material-icons">chevron_right</i>Kezdőoldal</h1>
        </div>
        <div class="content-panel-top-btn-group">
          <button class="btn btn-primary" type="button" v-on:click="setupDownload()"><i class="fa fa-download"></i>Kártyaolvasó illesztő letöltése</button>
        </div>
        <div class="panel">
          <div class="panel-heading">
            <h4>Üdvözöljük</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12">
                A rendszer használatához válasszon a bal oldali menüpontok közül!
              </div>
            </div>
          </div>
          <div class="panel-heading">
            <h4>Letölthető dokumentumok</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12">
              <section v-for="doc in docs">
                <a v-bind:href="'docs/'+ doc.file" target="_blank" class="active">{{doc.name}}</a> - {{doc.date}} (v{{doc.version}})<br/>
              </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      docs: []
    }
  },
  mounted: function() {
    var _this = this;

    this.$root.ajax('home/index', {
      success: function(response) {
        _this.docs = response.docs;
      }
    });
  },
  methods: {
    setupDownload () {
      window.open('/setup.exe');
    }
  }
}
</script>




// WEBPACK FOOTER //
// home.vue?34d42026